import { queryOptions, useQuery } from "@tanstack/react-query";

import { redirectToLogout } from "../auth/auth.utils";
import { ApiResponse } from "../dtos/api-respone.model";
import { User } from "../dtos/user.model";
import { MeService } from "../services/me-service";

export const meQueries = {
  details: queryOptions({
    queryKey: ["get-me"],
    queryFn: fetchMe,
  }),
};

export function useMeQuery() {
  return useQuery(meQueries.details);
}

async function fetchMe() {
  try {
    return await MeService.get();
  } catch (error: unknown) {
    // Refresh/access tokens can remain valid even after a user is deleted.
    // A 404 from /me means the session is no longer associated with user, so log out.
    if ((error as ApiResponse<User>)?.meta?.error?.statusCode === 404) {
      redirectToLogout();
    }
    throw error;
  }
}
